/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Reset_ButtonInputs */

const en_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Form`)
};

const fr_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser le formulaire`)
};

const de_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formular zurücksetzen`)
};

const it_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di ripristino`)
};

const ru_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить форму`)
};

const es_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer formulario`)
};

const zh_cn2_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置表单`)
};

const ja_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォームをリセット`)
};

const hi_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉर्म रीसेट करें`)
};

const pt_pt2_event_group_metadata_reset_button = /** @type {(inputs: Event_Group_Metadata_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir formulário`)
};

/**
* | output |
* | --- |
* | "Reset Form" |
*
* @param {Event_Group_Metadata_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_reset_button = /** @type {((inputs?: Event_Group_Metadata_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_reset_button(inputs)
	if (locale === "de") return de_event_group_metadata_reset_button(inputs)
	if (locale === "it") return it_event_group_metadata_reset_button(inputs)
	if (locale === "ru") return ru_event_group_metadata_reset_button(inputs)
	if (locale === "es") return es_event_group_metadata_reset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_reset_button(inputs)
	if (locale === "ja") return ja_event_group_metadata_reset_button(inputs)
	if (locale === "hi") return hi_event_group_metadata_reset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_reset_button(inputs)
	return en_event_group_metadata_reset_button(inputs)
});